module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.f5648c7c.ttf";